<template>
  <!-- <div class="mapModal">
   
    <div
      class="mapImg"
      :style="{
        backgroundImage:
          'url(' +
          require('@/assets/images/Belfast/Maps/' + imgName) +
          ')',
      }"
    >
       <div class="modalCloseButton bottom" @click="closeModal">
        <i class="fas fa-expand"></i>
      </div> 
      <div class="modalCloseButton top" @click="closeModal">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </div> -->
  <div>
  <transition name="modal" id="new-modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modalCloseButton top" @click="showModalClose">
                  <i class="fas fa-times"></i>
                </div>
                
              <div class="modal-body">
                <slot name="body">
                  <div class="align-center-of-screen">
                  <!-- <img :src="require(`@/assets/images/Belfast/Maps/${imgName}`)"> -->
                    <inner-image-zoom :src="require(`@/assets/images/Belfast/Maps/${imgName}`)" />
                  </div>
                </slot>
              </div>
           
          </div>
        </div>
        </div>
      </transition>
  </div>
</template>

<script>
import InnerImageZoom from 'vue-inner-image-zoom'
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css'
export default {
  name: "Modal",
  props: { Selected: Number, imgName:String },
  data() {
    return {};
  },
  components: {
    InnerImageZoom
  },
 
  methods: {
    closeModal() {
      this.$parent.closeModal();
    },
    showModalClose() {
      this.$parent.showModalClose();
    },
  },
};
</script>

<style lang="scss" scoped>
.mapModal {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: block;
  // left: 0;
  // right: 0;
  background-color: #fafafa;
  padding: 0;
  max-height: 70%;
  width: 85%;
  margin: auto;
  overflow-y: auto;
  margin-top: 3rem;

  border-radius: 2px;
  will-change: top, opacity;
  box-shadow: 0 0 24px 0;

  position: absolute;
  z-index: 10;
}

.mapImg {
  width: 100%;
  min-height: 80vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.modalCloseButton {
  width: 40px;
  height: 40px;
  cursor: pointer;
  position: absolute;
  z-index:99999999;
   right: 10px;
  // border-radius: 10px;
  // background-color: #ffffff;
 // box-shadow: 0 0 5px 4px rgba(29, 50, 92, 0.07);
&.top{
top: 10px;
}
&.bottom{
  bottom: 10px;
}
  i {
    font-size: 25px;
    padding: 7.5px;
    color: #4b789c;
  }
}


.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 90vw;
  height:60vw;
  position: relative;
  margin: 6% auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.align-center-of-screen{
      width: 100%;
     display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    justify-content: center;
    figure{
      width:30%;
    }
}
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  height: 71%;
    // width: 98%;
  //margin: 20px 0;
  // width: 100%;
    padding: 2rem 0rem;
    // overflow: scroll;
    display: flex;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
